import "../assets/Alert.css";
import { jsxs as t, jsx as s } from "preact/jsx-runtime";
import { c as r } from "./index.2w0W-O47.js";
import { l as h, E as m, Y as p, k as I, u as f } from "./Icon.CPrkqxma.js";
const g = "_root_1r2ds_1", v = "_success_1r2ds_7", C = "_warning_1r2ds_11", w = "_error_1r2ds_15", B = "_info_1r2ds_19", k = "_icon_1r2ds_24", x = "_headline_1r2ds_25 pulse-type-bold", b = "_description_1r2ds_48", j = "_closeButton_1r2ds_57", o = {
  root: g,
  success: v,
  warning: C,
  error: w,
  info: B,
  icon: k,
  headline: x,
  description: b,
  closeButton: j
}, R = ({
  type: n,
  headline: i,
  description: e,
  showCloseButton: a = !0,
  onClose: l = () => {
  },
  children: d,
  ..._
}) => {
  const c = { class: r([o.icon, o[n]]) }, u = n === "error" ? /* @__PURE__ */ s(m, { ...c }) : n === "warning" ? /* @__PURE__ */ s(p, { ...c }) : n === "success" ? /* @__PURE__ */ s(I, { ...c }) : /* @__PURE__ */ s(f, { ...c });
  return /* @__PURE__ */ t(
    "div",
    {
      class: r(o.root, _.class, o[n]),
      "data-testId": "alert",
      "aria-live": "polite",
      children: [
        u,
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ s("div", { class: r(o.headline, o[n]), children: i }),
          /* @__PURE__ */ s("div", { class: o.description, children: e }),
          d
        ] }),
        a && /* @__PURE__ */ s("button", { onClick: l, class: o.closeButton, children: /* @__PURE__ */ s(h, { "data-test-name": "alertCloseIcon" }) })
      ]
    }
  );
};
export {
  R as A
};
